import Vue from 'vue'
import VueRouter from 'vue-router'
//import ProductSelection from '../views/ProductSelection'
import Steps from '../views/Steps'
import NotFound from '../views/NotFound'
import scrollBehavior from './scrollBehavior'

Vue.use(VueRouter)

const routes = [
    /*{
        path: '/',
        name: 'product-selection',
        component: ProductSelection,
        meta: {
            scrollToTop: true
        }
    },*/
    {
        path: '/:productPathSegment',
        name: 'steps',
        component: Steps
    },
    {
        path: '*',
        component: NotFound,
        meta: {
            scrollToTop: true
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_ROUTER_BASE_URL || window.location.pathname.slice(0, window.location.pathname.lastIndexOf('/') + 1),
    routes,
    scrollBehavior
})

export default router
